var _defs, _g, _script;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScanAnimation = function SvgScanAnimation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eufxHXZWqb71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 232 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "eufxHXZWqb74-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "eufxHXZWqb74-filter-blur-0",
    stdDeviation: "9,9",
    result: "result"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eufxHXZWqb72",
    transform: "translate(0-11.531458)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("line", {
    x1: -116,
    y1: 0,
    x2: 99,
    y2: 0,
    transform: "translate(124.500001 23.38681)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 219.097713,
    height: 14,
    rx: 0,
    ry: 0,
    transform: "matrix(1 0 0 0.5 6.451144 19.88681)",
    filter: "url(#eufxHXZWqb74-filter)",
    fill: "currentColor",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _script || (_script = /*#__PURE__*/React.createElement("script", null)));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScanAnimation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scan-animation.1b0f00c1f760b8ad20cab6e827ac99f7.svg";